<ion-card class="notification-popup">
  <ion-card-content>
    <ul>
      <li *ngFor="let notification of notificationList">
        <h2 class="notify-text" *ngIf="notification.type === 'newOrder'">
          New Order <span class="highlight">{{ notification.orderNumber }}</span> has been placed and status is <span class="highlight">{{notification.status}}</span>.
        </h2>
        <h2 class="notify-text" *ngIf="notification.type === 'orderStatus'">
          Order <span class="highlight">{{ notification.orderNumber }}</span> status has been updated to <span class="highlight">{{ notification.status }}</span>.
        </h2>
      </li>
    </ul>
  </ion-card-content>  
  <ng-template #noNotification>
    <div class="d-flex justify-content-center text-center py-4">
      <span>No Notification Present</span>
    </div>
  </ng-template>
</ion-card>
